import * as React from "react";
// url
import { VingleURL } from "@vingle/wtf-sdk/url";
// components
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";
// helpers
import { isBrowser } from "@vingle/wtf-sdk/helpers/envChecker";
import { useRouter } from "@vingle/wtf-sdk/helpers/hook";
// styles
const styles = require("./navbar.scss");

interface ISignUpNavbarProps {
  onRequestOpenAppDownloadDialog: () => void;
}

export default React.memo(
  ({ onRequestOpenAppDownloadDialog }: ISignUpNavbarProps) => {
    const { location } = useRouter();
    const redirectUrl = isBrowser()
      ? `${location.pathname}?${location.search}`
      : "";
    let leftItems: React.ReactNode;
    let rightItems: React.ReactNode;

    leftItems = (
      <ul className={styles.left}>
        <li>
          <Link to={new VingleURL.Discover().toString()}>
            <FormattedMessage id="signup.discover" />
          </Link>
        </li>
        <li>
          <a href="mailto:ads@vingle.net">
            <FormattedMessage id="signup.business" />
          </a>
        </li>
        <li>
          <a href="http://careers.vingle.net">
            <FormattedMessage id="signup.jobs" />
          </a>
        </li>
        <li>
          <a onClick={onRequestOpenAppDownloadDialog}>
            <FormattedMessage id="signup.mobile_app" />
          </a>
        </li>
      </ul>
    );
    rightItems = (
      <ul className={styles.right}>
        <li className={styles.login}>
          <Link
            to={new VingleURL.SignIn().toLocation({
              query: {
                redirect_url: redirectUrl,
              },
            })}
          >
            <FormattedMessage id="log_in" />
          </Link>
        </li>
      </ul>
    );

    return (
      <nav className={styles.navWrapper}>
        <div className={`${styles.container} clearfix`}>
          {leftItems}
          {rightItems}
        </div>
      </nav>
    );
  },
);
